import AnimationRoute from '@/views/layout/AnimationRoute';
import {
    getAntdBorderRadius,
    getAntdControlHeight,
    getAntdFontSize,
    getViewportFontSize
} from '@/styles/responsive';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import 'antd/dist/reset.css';
import '@/styles/common.less';
import { ReactElement, useEffect, useMemo, useState } from 'react';

function App(): ReactElement {
    const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth);

    useEffect(() => {
        const updateViewportWidth = () => {
            setViewportWidth(window.innerWidth);
        };

        updateViewportWidth();
        window.addEventListener('resize', updateViewportWidth);

        return () => {
            window.removeEventListener('resize', updateViewportWidth);
        };
    }, []);

    const rootFontSize = useMemo(() => getViewportFontSize(viewportWidth), [viewportWidth]);

    const antdTheme = useMemo(() => {
        const fontSize = getAntdFontSize(rootFontSize);
        return {
            token: {
                fontSize,
                controlHeight: getAntdControlHeight(fontSize),
                borderRadius: getAntdBorderRadius(fontSize)
            }
        };
    }, [rootFontSize]);

    useEffect(() => {
        document.documentElement.style.setProperty('--app-font-size', `${rootFontSize}px`);
    }, [rootFontSize]);

    return (
        <ConfigProvider theme={antdTheme}>
            <Router>
                <AnimationRoute />
            </Router>
        </ConfigProvider>
    );
}

export default App;
